import { useCallback, useState } from "react";
import ContributorResponseResource from "common/resources/Project/Config/Contributor/ContributorResponseResource";

export enum EContributorModal {
	CREATE_CONTRIBUTOR = "CREATE_CONTRIBUTOR",
	EDIT_CONTRIBUTOR = "EDIT_CONTRIBUTOR",
	DELETE_CONTRIBUTOR = "DELETE_CONTRIBUTOR",
}

export const useContributorModal = () => {
	const [openedModal, setOpenedModal] = useState<EContributorModal | null>(null);
	const [selectedContributor, setSelectedContributor] = useState<ContributorResponseResource | null>(null);

	const isModalOpen = useCallback((modal: EContributorModal) => openedModal === modal, [openedModal]);

	const onCloseModal = useCallback(() => {
		setOpenedModal(null);
		setSelectedContributor(null);
	}, []);

	const onOpenCreateContributorModal = useCallback(() => {
		setOpenedModal(EContributorModal.CREATE_CONTRIBUTOR);
	}, [setOpenedModal]);

	const onOpenEditContributorModal = useCallback(
		(contributor: ContributorResponseResource) => {
			setOpenedModal(EContributorModal.EDIT_CONTRIBUTOR);
			setSelectedContributor(contributor);
		},
		[setOpenedModal],
	);

	const onOpenDeleteContributorModal = useCallback(
		(contributor: ContributorResponseResource) => {
			setOpenedModal(EContributorModal.DELETE_CONTRIBUTOR);
			setSelectedContributor(contributor);
		},
		[setOpenedModal],
	);

	return { selectedContributor, isModalOpen, onCloseModal, onOpenCreateContributorModal, onOpenEditContributorModal, onOpenDeleteContributorModal };
};
